export default "__VITE_ASSET__BFnDXRAG__"